import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function Hero() {
  return <header className="relative overflow-hidden bg-navy-900 px-4 pb-12 pt-8 text-white sm:pb-16 sm:pt-12" data-id="element-185" data-mp="cv31nprc02co">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-[radial-gradient(circle_at_50%_0%,rgba(46,163,232,0.28),transparent_65%)]" aria-hidden="true" data-id="element-186" data-mp="hwinvl58wewn" />
      <div className="relative mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-187" data-mp="qub2so721kji">
        <div className="flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 ring-1 ring-white/15" data-id="element-188" data-mp="vnng426aa4wy">
          <span className="text-base" aria-hidden="true" data-id="element-189" data-mp="10kxew8fkbsxg">
            🦷
          </span>
          <span className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-200" data-id="element-190" data-mp="15lte48oyyqwj">
            The Prosthodontics Study System
          </span>
        </div>

        <h1 className="mt-6 font-display text-[34px] font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-191" data-mp="9o2rhq0h4yp6">
          Organize and review Prosthodontics in{' '}
          <span className="italic text-aqua-400" data-id="element-192" data-mp="3vv11sqbhs88n">just 15 minutes a day</span>
        </h1>

        <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-white/75 sm:text-lg" data-id="element-193" data-mp="3vwu7o3ea6ofl">
          A visual step-by-step study system that shows you what to study, what to review next, and how the
          major Prosthodontics concepts connect—so you can stop jumping between lecture slides, textbooks,
          notes, and PDFs. Includes{' '}
          <strong className="font-bold text-white" data-id="element-194" data-mp="infrls2pkax8">10 core modules</strong>,{' '}
          <strong className="font-bold text-white" data-id="element-195" data-mp="enfecarci5rr">6 study tools</strong>, and{' '}
          <strong className="font-bold text-white" data-id="element-196" data-mp="1b4jq6z5ggio3">50+ visual maps</strong>, checklists, comparison guides, and
          review resources.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/3JGrNWwL6maKWmHMs4LJEA/PROSTHO-EN.png" alt="The complete PROSTHO 360 system: 10 core modules and 6 bonus study tools" className="mt-8 w-full max-w-2xl" width={1080} height={1080} data-id="element-197" data-mp="16ciizrn59i4x" />

        <p className="mt-2 text-[11px] font-extrabold uppercase tracking-[0.16em] text-aqua-200" data-id="element-198" data-mp="2qvkwysuex1vu">
          10 core modules + 6 bonus study tools
        </p>

        <div className="mt-7 w-full" data-id="element-199" data-mp="2huwi5vx72xhw">
          <CheckoutButton id="hero-cta" label="Get Prostho 360™" sub="Instant digital access · One-time payment of $27 · Lifetime access · 7-Day Guarantee" data-id="element-200" data-mp="2htutupr64ei8" />
        </div>

        <div className="mt-8 w-full" data-id="element-201" data-mp="27z2zdusvu7ro">
          <Countdown label="Special launch offer ends in:" tone="dark" data-id="element-202" data-mp="2cw36m91gxgkd" />
        </div>

        <div className="mt-6 w-full" data-id="element-203" data-mp="65vhcdlvxc23">
          <ScarcityBar tone="dark" data-id="element-204" data-mp="66ya6r2rpokn" />
        </div>

        <p className="mt-5 flex items-center gap-2 text-[12px] text-white/60" data-id="element-205" data-mp="64276oc2c9pc">
          <ShieldCheckIcon className="h-4 w-4 text-aqua-400" aria-hidden="true" data-id="element-206" data-mp="b2vpqv67iqwd" />
          Currency conversion is automatically adjusted based on your country.
        </p>
      </div>
    </header>;
}